module.exports = __webpack_public_path__ + "fan.jpg?3648ef71da562f4e5799cf385ca05c70";